import clsx from "clsx";

/**
 * The chrome the sign-in, register and forgot-password forms share; the theme
 * gave each its own block with the same rules. Each form is a "form" group
 * carrying useAuthForm()'s data attributes, which these read.
 */

/** The logo or the line of copy above the fields. */
export const headClass = "mb-10 text-center";

/**
 * The reply box, out of the layout until there is a reply: neutral, green on
 * a success and red on an error.
 */
export const messageClass = clsx(
  "mx-auto my-10 hidden max-w-[500px] rounded-[4px] border border-[#ddd] bg-[#f8f9fa] p-4 text-center text-[#333] shadow-[0_2px_10px_rgba(0,0,0,0.1)]",
  "group-data-[status=success]/form:border-[#badbcc] group-data-[status=success]/form:bg-[#d1e7dd] group-data-[status=success]/form:text-[#0f5132]",
  "group-data-[status=error]/form:border-[#f5c2c7] group-data-[status=error]/form:bg-[#f8d7da] group-data-[status=error]/form:text-[#842029]",
  "group-data-message/form:block",
);

export const messageHeadClass = "mb-2.5 text-[20px]";

export const messageBodyClass = "text-[16px]";

export const bodyClass = "mb-7.5";

export const rowClass = "not-last:mb-5";

export const labelClass =
  "mb-1.5 block pl-1.5 font-das text-[14px] leading-none font-light text-secondary";

export const inputClass = clsx(
  "h-[45px] w-full rounded-[12px] border border-[#979797] px-5 py-0 font-das text-[16px] font-light text-[#636366] outline-none",
  "placeholder:text-[#979797] focus:border-secondary",
);

export const submitClass = "not-last:mb-7.5";

/** darken($c-secondary, 5%) on hover. */
export const submitButtonClass =
  "w-full rounded-[20px] border-0 bg-secondary px-5 py-3.5 font-das text-[16px] font-medium text-white outline-none hover:bg-[#015fcb]";

export const footerClass =
  "text-center font-das text-[16px] font-light text-[#636366]";
